module.exports = __webpack_public_path__ + "img/checked_w.6e19f995.svg";